export class AboutUsService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;

		this.aboutUsResourceUrl = this.apiService.getResourceUrl('menus/AboutUs');

		this.aboutUsResource = this.$resource(this.aboutUsResourceUrl);
	}

	_getOverviewDetailsObject(details) {
		return {
			contentId: details.content_id,
			menuId: details.menu_id,
			displayName: details.display_name,
			name: details.name,
			title: details.title,
			image: details.image || '',
			description: details.description,
			overview: details.overview,
			slug: details.slug || '',
			ada: details.ada ? this._getAdaTextObject(details.ada) : {}
		}
	}

	_getAdaTextObject({overview_image_text: overviewImageText}) {
		return {
			overviewImageText
		}
	}

	_getChildrenObject(details) {
		return details.map(value => this._getOverviewDetailsObject(value));
	}

	getAboutUsDetails(details) {
		return {
			menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
			children: this._getChildrenObject(details.data.children)
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/about-us/about-us.service.js